import React, { useState, useEffect, useRef } from 'react'
import Cookies from 'universal-cookie';
import { BuildingOffice2Icon, CalendarIcon, ChartBarIcon, CheckCircleIcon, ClockIcon, IdentificationIcon, InformationCircleIcon, UserIcon, XCircleIcon } from '@heroicons/react/24/outline';
import SearchForm from '../components-contabilidad-analisis/SearchForm';
import ResultadoDataGrid from '../tools/CustomDataGrid';
import Pagination from '../components-contabilidad-analisis/Pagination';
import WarningModal from '../components-modals/WarningModal';
import { Transition } from '@headlessui/react';
import Layout from '../Layout';
import Container from '../components-layout/Container';
import Header from '../components-layout/Header';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { DocumentCheckIcon } from '@heroicons/react/24/outline';
import { fetchApi } from '../tools';
import { useSelector } from 'react-redux';

import { useSedes } from '../vistaAsistencia/hooks/useCampus';
import { useNiveles } from '../vistaAsistencia/hooks/useNiveles';
import { useGrados } from '../vistaAsistencia/hooks/useGrados';
import { useSecciones } from '../vistaAsistencia/hooks/useSecciones';
import { getDataNotas } from './services/Notas.service';

const NotasAdminIndex = () => {

    const claseBotones =
    "inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm";

  const columnasNormal = [
    { name: "Carnet", id: 1,  type: "text", resaltado: false },
    { name: "Alumno", id: 23, type: "text", resaltado: false },
    { name: "Estado", id: 18, type: "text", resaltado: false },
    {
      name: "Notas",
      id: 999,
      type: "text",
      resaltado: false,
      text: "Visualizar",
      alt: "Seleccionar",
    },
  ];

  const columnasTodosCiclos = [
    { name: "Carnet", id: 1,  type: "text", resaltado: false },
    { name: "Alumno", id: 23, type: "text", resaltado: false },
    { name: "Ciclo", id: 17, type: "text", resaltado: false },
    { name: "Sede",    id: 5,  type: "text", resaltado: false },
    { name: "Grado",   id: 11, type: "text", resaltado: false },
    { name: "Estado", id: 18, type: "text", resaltado: false },
    {
      name: "Notas",
      id: 999,
      type: "text",
      resaltado: false,
      text: "Visualizar",
      alt: "Seleccionar",
    },
  ];

  const columnasNotas = [
    { name: "Materia",  id: 2,  type: "text", resaltado: false },
    { name: "Unidad 1", id: 3,  type: "text", resaltado: false },
    { name: "Unidad 2", id: 4,  type: "text", resaltado: false },
    { name: "Unidad 3", id: 5,  type: "text", resaltado: false },
    { name: "Unidad 4", id: 6,  type: "text", resaltado: false },
    { name: "Promedio", id: 10, type: "text", resaltado: false },
    { name: "Faltan para ganar con 60", id: 11, type: "text", resaltado: false },
  ];

  const [idSede, setIdSede] = useState("");
  const [idNivel, setIdNivel] = useState("");
  const [idGrado, setIdGrado] = useState("");
  const [idSeccion, setIdSeccion] = useState("");
  const [verNotas, setverNotas] = useState(false)
  const [alumnoSeleccionado, setAlumnoSeleccionado] = useState()
  const [buscarEnCiclos, setBuscarEnCiclos] = useState("");
  const [datos, setDatos] = useState([])

  const [ciclo, setCiclo] = useState(2024);
  const [columnas, setColumnas] = useState(columnasNormal);
  
  
  const [comando, setComando] = useState("");
  const [titulo, setTitulo] = useState("");
  const [rawData, setRawData] = useState([]);
  const [masterAlumnos, setMasterAlumnos] = useState([]);
  
  const [esCodigovalido, setEsCodigoValido] = useState(false);
  const refSeccion = useRef(null);
  /////////
  const [sedes] = useSedes([])
  const [niveles, setNiveles] = useNiveles([], idSede);
  const [secciones, setSecciones] = useSecciones([], idSede, idGrado)
  const [grados, setGrados ] = useGrados([], idSede, idNivel);
  /////////
  const topRef = useRef(null);
  const sedesRef = useRef(null);
  const user = useSelector((state) => state.auth.user);
  const IdEmp = useSelector((state) => state.auth.IdEmp);
  const userObj = JSON.parse(user);
  const [todos, setTodos] = useState([]);
  const [opcion, setOpcion] = useState("");
  const [todosCiclos, setTodosCiclos] = useState(false);
  const [clickeable, setClickeable] = useState(false);
  
  userObj.LoginId = userObj.LoginId.split(" ")
  .map((x) => {
      return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
    })
    .join(" ");
    
    const cookies = new Cookies();
    const urlState = useSelector(state => state.url.urlSchoolApi)
    const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState
    
    const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
    const sede = useSelector((state) => state.auth.IdSede);
    
    const [loading, setLoading] = useState(false);
    const [controlesBloqueados, setControlesBloqueados] = useState(false);
    const [botonesVisibles, setBotonesVisibles] = useState(false);
    const [modal, setModal] = useState({
        show: false,
    msg: "",
    ok: false,
  });
  
  const [filterData, setFilter] = useState([]);
  const searchParams = ["Carnet", "NombreCompleto"];
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 12;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentRecords = filterData?.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const nPages = Math.ceil(filterData?.length / recordsPerPage);
  
  const callSecciones = async (idgrado) => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "SECCIONES",
        Idsede: idSede,
        idgrado: idgrado,
      },
    });
    setSecciones(data);
    setIdSeccion("");
  };

  const callCiclo = async () => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "CICLO_ACTUAL",
      },
    });
    setCiclo(data[0].Ciclo);
  };

  const bloquear = () => {
    setControlesBloqueados(true);
  };

  const callAlumnos = async () => {
    setLoading(true)
    setClickeable(true)
    bloquear();
    setFilter([]);
    setRawData([]);
    let copiaTodos = [];
    let data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "ALUMNOS_CICLO_ACTUAL",
        Idsede: idSede,
        idgrado: idGrado,
        IdSeccion: idSeccion,
        idciclo: ciclo,
      },
    });
    let sortedTodos = data.sort((r1, r2) =>
      r1.Condicion > r2.Condicion ? 1 : r1.Condicion < r2.Condicion ? -1 : 0
    );
    setTodos([...sortedTodos]);
    setRawData([...copiaTodos]);
    setFilter([...copiaTodos]);

    setTitulo("Notas");
    setColumnas([...columnasNormal]);
    setEsCodigoValido(true);
    setLoading(false);
  };

  useEffect(() => {
    verDatosTipo();
  }, [todos]);

  const buscarTodosCiclos = async () => {
    setLoading(true);
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "ALUMNOS",
        Aspirante: buscarEnCiclos,
      },
    });
    setTodos([...data]);
    setFilter([...data]);
    setLoading(false);
  }
  const callNiveles = async (idsede) => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "NIVELES",
        Idsede: idsede,
      },
    });
    setNiveles(data);
  };

  const callGrados = async (idnivel) => {
    const data = await fetchApi({
      url: `${url}/utils/busquedas`,
      headers: headers,
      content: {
        opcion: "GRADOS_ALUMNOS",
        Idsede: idSede,
        idnivel: idnivel,
      },
    });
    setGrados(data);
  };

  const handleSede = (idsede) => {
    setNiveles([]);
    setGrados([]);
    setSecciones([]);
    setIdSede(idsede);
    callNiveles(idsede);
    setBotonesVisibles(false);
  };

  const handleNivel = (e) => {
    setGrados([])
    setSecciones([]);
    setBotonesVisibles(false);
    setIdGrado("");
    setIdSeccion("");
    setIdNivel(e.target.value);
    callGrados(e.target.value);
  };

  const handleGrado = (e) => {
    setBotonesVisibles(false);
    setIdGrado(e.target.value);
    setSecciones([]);
    setIdSeccion("");
    //refSeccion.current.value = ""
    callSecciones(e.target.value);
  };

  const handleSeccion = (e) => {
    setIdSeccion(e.target.value);
    idGrado ? setBotonesVisibles(true):setBotonesVisibles(false);
  };

  const formateador = (alumno, notas1) => {
    if(!notas1.length){
        setLoading(false)
        setModal({
            ok:false,
            show:true,
            msg:`El carnet ${alumno.Carnet} no tiene notas para mostrar`
        })
    }else{
    setverNotas(true);
    notas1.forEach(e => {
      if(e['unidadI'] === 0)   e['unidadI']   = "";
      if(e['unidadII'] === 0)  e['unidadII']  = "";
      if(e['UnidadIII'] === 0) e['UnidadIII'] = "";
      if(e['UnidadIV'] === 0)  e['UnidadIV']  = "";
      if(e['promedio'] === 0)  e['promedio']  = "";
    })
    setDatos(notas1);
    setLoading(false);
    }
  }

  const handleAlumnoCta = async (alumno, text) => {
    setLoading(true);
    console.log(alumno)
    const notas1 = await getDataNotas(url, headers, alumno.Carnet, '1', alumno.IdSede, alumno.IdSeccion, alumno.IdCiclo); // solicitar IdSeccion para enviar la petición get
    let copiaAlumno = alumno
    copiaAlumno.solvente = notas1[0]?.solvente || false
    console.log('alumno: ', copiaAlumno)
    formateador(alumno, notas1);
    setAlumnoSeleccionado(copiaAlumno);
  };

  const cancelar = () => {
    setverNotas(false);
    setClickeable(false);
    setControlesBloqueados(false);
    resetArrays();
    setFilter([]);
    setNiveles([]);
    setGrados([]);
    setSecciones([]);
  };

  const resetArrays = () => {
    setMasterAlumnos([]);
    callNiveles(idSede);
    setBotonesVisibles(false);
  };

  const verDatosTipo = (opcion = "Todos") => {
    setCurrentPage(1);
    setOpcion(opcion);
    const opciones = {
      Todos: () => {
        setRawData([...todos]);
        setFilter([...todos]);
        setTitulo("Notas");
        setColumnas(columnasNormal);
        setEsCodigoValido(true);
      },
    };
    opciones[opcion]();
  };

  const handleQuery = (values) => {
    doSearch(values.query.trim());
    setCurrentPage(1);
  };

  useEffect(() => {
    setDatos([])
  }, [todosCiclos])
  
  const doSearch = (query) => {
    if (query === null) {
      setFilter(rawData);
    } else {
      setFilter(
        rawData.filter((x) => {
          return searchParams.some((y) => {
            return (
              x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        })
      );
    }
  };

  const mostrarAdvertencia = () => {
    cancelar();
  };

  const callTodosCiclos = () => {
    setTodosCiclos(!todosCiclos);
    cancelar();
  };

  useEffect(() => {
    setIdSede(sede);
    sedesRef.current.value = sede;
    callNiveles(idSede);
  }, [sedes]);

  useEffect(() => {
    callCiclo()
  }, [])

  return (
    <>
    <WarningModal
        open={loading ? true : false}
        image={<img src="./img/loader.gif" alt="loading" />}
        opacity="bg-opacity-100"
      />
      <Transition ref={topRef} show={true}>
        <Layout userObj={userObj} activeTab="Notas">
          <Container className=" w-full p-2 lg:p-8">
            <Header title="Notas administrativo" logo={DocumentCheckIcon} />
          
            <WarningModal
              open={modal.show ? true : false}
              image={
                comando === "Seleccionar" ? null : modal.ok ? (
                  <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                ) : (
                  <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
                )
              }
              title={comando === "Seleccionar" ? "Cambiar perfil" : "Aviso"}
              subtitle={<span>{modal.msg}</span>}
              opacity="bg-opacity-50"
            >
                <div className="mt-5 sm:mt-6">
                  <button
                    onClick={() => {
                      if (modal.reload) {
                        window.location.reload();
                      }
                      setModal((curr) => ({
                        ...curr,
                        show: false,
                        reload: false,
                      }));
                    }}
                    type="button"
                    className={claseBotones}
                  >
                    Entendido
                  </button>
                </div>
           
            </WarningModal>

            <div className="flex flex-col md:flex-row ">
              <div className="basis-1/4  bg-primarioMira m-2 rounded-lg p-2">
                <div className="basis-1/2 pt-2 bg-primarioMira   rounded-lg">
                  {!todosCiclos ? (
                    <div
                      className={
                        "px-2 py-2 grid grid-cols-1 rounded-lg bg-secundarioMira shadow-sm shadow-white"
                      }
                    >
                      <p className={"text-white /font-medium mb-2 "}>
                      {`Búsqueda en el ciclo ${ciclo}`}
                      </p>
                      
                      <label className="text-white text-sm">Sede</label>
                      <select
                        ref={sedesRef}
                        onChange={(e) => handleSede(e.target.value)}
                        name="IdSede"
                        type="select"
                        disabled={controlesBloqueados}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                      >
                        <option value="">---Selecciona Sede---</option>
                        {sedes.map((sede) => (
                          <option key={sede.IdSede} value={sede.IdSede}>
                            {sede.Sede}
                          </option>
                        ))}
                      </select>
                      <label className="text-white text-sm">Nivel</label>
                      <select
                        onChange={(e) => handleNivel(e)}
                        name="IdNivel"
                        type="select"
                        disabled={controlesBloqueados}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                      >
                        <option value="">---Selecciona Nivel---</option>
                        {niveles.map((nivel) => (
                          <option key={nivel.IdNivel} value={nivel.IdNivel}>
                            {nivel.Nivel}
                          </option>
                        ))}
                      </select>

                      <label className="text-white text-sm">Grado</label>
                      <select
                        onChange={(e) => handleGrado(e)}
                        name="IdGrado"
                        type="select"
                        disabled={controlesBloqueados}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                      >
                        <option value="">---Selecciona Grados---</option>
                        {grados.map((grado) => (
                          <option key={grado.IdGrado} value={grado.IdGrado}>
                            {grado.Grado}
                          </option>
                        ))}
                      </select>

                      <label className="text-white text-sm">Seccion</label>
                      <select
                        ref={refSeccion}
                        onChange={(e) => handleSeccion(e)}
                        name="IdSeccion"
                        type="select"
                        disabled={controlesBloqueados}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                      >
                        <option value="">---Selecciona Secciones---</option>
                        {secciones.map((seccion) => (
                          <option
                            key={seccion.IdSeccion}
                            value={seccion.IdSeccion}
                          >
                            {seccion.Seccion}
                          </option>
                        ))}
                      </select>
                      <div className={"mr-2 mt-4 text-white gap-2"}>
                          <input
                            id="chkciclos"
                            type="checkbox"
                            className={"mr-2 rounded-sm text-azulBrillanteMira w-5 h-5"}
                            checked={todosCiclos}
                            onChange={() => callTodosCiclos()}
                          ></input>
                          <label htmlFor="chkciclos" className={"m-l-2 "} onClick={(e) => e.preventDefault()}>
                            Seleccione para activar o desactivar la búsqueda en ciclos
                            anteriores
                          </label>
                      </div>
                      {botonesVisibles ? (
                        <div>
                          {controlesBloqueados ? (
                            <button
                              onClick={() => mostrarAdvertencia()}
                              className="float-right  rounded-md border border-transparent bg-secundario mt-2 py-2 px-4  text-sm font-medium text-white  hover:bg-secundarioMira hover:border-azulLogos focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                            >
                              Limpiar
                            </button>
                          ) : (
                            <button
                              onClick={() => callAlumnos()}
                              className="float-right basis-4/4 rounded-md border border-transparent bg-azulBrillanteMira mt-2 py-2 px-4 text-sm font-medium text-white  hover:bg-secundarioMira hover:border-azulLogos focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                            >
                              Buscar
                            </button>
                          )}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className={"mr-2 mt-4 text-white gap-2 p-2 "}>
                  {todosCiclos ? (
                    <div
                      className={
                        "shadow-sm shadow-white w-full rounded-lg p-2 flex flex-col mt-8 bg-primarioMira"
                      }
                    >
                      <p className={" text-white mb-2 bg-primarioMira"}>
                        Búsqueda en todos los ciclos (Por Nombres y Apellidos)
                      </p>
                      <div className={"flex flex-row bg-primarioMira"}>
                        <input
                          type="text"
                          className={
                            "rounded-l-md w-full border-gray-300 shadow-sm text-gray-800 focus:border-secundario focus:ring-secundario"
                          }
                          placeholder="Ingrese Nombre y Apellido del alumno"
                          onChange={(e) => setBuscarEnCiclos(e.target.value)}
                        ></input>
                        <button
                          className={
                            "bg-azulBrillanteMira text-white rounded-r-md p-2"
                          }
                          onClick={() =>
                            buscarEnCiclos
                              ? buscarTodosCiclos()
                              : console.log("no hay dato para buscar")
                          }
                        >
                          Buscar
                        </button>
                      </div>

                      <div className={"mr-2 mt-4 text-white gap-2"}>
                          <input
                            id="chkciclos"
                            type="checkbox"
                            className={"mr-2 rounded-sm text-azulBrillanteMira w-5 h-5"}
                            checked={todosCiclos}
                            onChange={() => callTodosCiclos()}
                          ></input>
                          <label htmlFor="chkciclos" className={"m-l-2"} onClick={(e) => e.preventDefault()}>
                            Seleccione para activar o desactivar la búsqueda en ciclos
                            anteriores
                          </label>
                      </div>

                    </div>
                  ) : null}
                  </div>
                </div>
                <div className="shadow-white shadow-sm m-4 bg-secundarioMira rounded-lg"></div>
              </div>
              <div className="lg:w-full basis-3/4 m-2 p-2 rounded-lg px-2 py-2 grid grid-cols-1  bg-secundarioMira shadow-sm shadow-white">
                
                {!verNotas?
                <>
                {grados.find(e => e?.IdGrado === idGrado)?.NotasBloqueadas ?
                 <div
                   aria-live="assertive"
                   className="flex w-full transition duration-500 ease"
                 >
                   <div className="flex w-full flex-col items-center space-y-4 /sm:items-end">
                     {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
                     <Transition show={true} className={"flex flex-row w-full px-2"}>
                       <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-red-200  shadow-lg ring-1 ring-black ring-opacity-5 transition data-[closed]:data-[enter]:translate-y-2 data-[enter]:transform data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in data-[closed]:data-[enter]:sm:translate-x-2 data-[closed]:data-[enter]:sm:translate-y-0">
                         <div className="p-4">
                           <div className="flex items-start">
                             <div className="flex-shrink-0">
                               <InformationCircleIcon aria-hidden="true" className="h-6 w-6 text-red-400" />
                             </div>
                             <div className="ml-3 w-0 flex-1 pt-0.5">
                               <p className="hidden text-sm font-medium text-red-900">{"Aviso"}</p>
                               <p className="mt-1 text-sm text-red-900">{"Las notas del grado seleccionado han sido bloqueadas por el director"}</p>
                             </div>
                           </div>
                         </div>
                       </div>
                     </Transition>
                   </div>
                 </div>
                :
                <p></p>
                }
                  <div className={"px-2"}>
                    <SearchForm handleQuery={handleQuery} />
                  </div>
                  <ResultadoDataGrid
                    headers={headers}
                    setModal={setModal}
                    columnas={todosCiclos?columnasTodosCiclos:columnas}
                    alumnos={currentRecords}
                    handleAlumno={handleAlumnoCta}
                    titulo={titulo}
                    subtitulo={"Listado de alumnos que coinciden con tu búsqueda"}
                    seleccion={true}
                    />
                    <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={filterData.length}
                    indexOfFirstRecord={indexOfFirstRecord}
                    indexOfLastRecord={indexOfLastRecord}
                    />
                  </>
                :
                <div className='flex flex-col'>
                   <div className='flex flex-col text-gray-100 p-2'>
                      <div className='flex flex-row gap-2 mb-4'>
                          <UserIcon className="w-6 h-6 text-gray-400 my-auto"/>
                          <p className='text-2xl font-medium'>{alumnoSeleccionado.NombreCompleto}</p> 
                      </div>
                      <div className='flex flex-row gap-2 mb-2'>
                          <IdentificationIcon className="w-6 h-6 text-gray-400 my-auto"/>
                          <p className='/text-2xl font-medium'>{alumnoSeleccionado.Carnet}</p>
                          <ChartBarIcon className="w-6 h-6 text-gray-400 my-auto"/>
                          <p className='text-gray-200'>{alumnoSeleccionado.GradoCompleto}</p>
                          <CalendarIcon className="w-6 h-6 text-gray-400 my-auto"/>
                          <p className='text-gray-200'>{`Ciclo ${alumnoSeleccionado.IdCiclo}`}</p>
                      </div>
                      <div className='flex flex-row gap-2'>
                          <BuildingOffice2Icon className="w-6 h-6 text-gray-400 my-auto"/>
                          <p className='text-gray-200'>{alumnoSeleccionado.Sede}</p>
                          <ClockIcon className="w-6 h-6 text-gray-400 my-auto"/>
                          <p className='text-gray-200'>{alumnoSeleccionado.NombrePlanCompleto}</p>
                        
                          {alumnoSeleccionado.EstadoAlumno === "Activo" ? 
                              <CheckCircleIcon className="w-6 h-6 text-green-500 my-auto"/>:
                              <XCircleIcon className="w-6 h-6 text-red-400 my-auto"></XCircleIcon>
                          }
                          <p className='text-gray-200 my-auto'>{alumnoSeleccionado.EstadoAlumno}</p>
                          {alumnoSeleccionado.solvente ? 
                              <CheckCircleIcon className="w-6 h-6 text-green-500 my-auto"/>:
                              <XCircleIcon className="w-6 h-6 text-red-400 my-auto"></XCircleIcon>
                          }
                          <p className='text-gray-200 my-auto'>{alumnoSeleccionado.solvente ? "Solvente": "Insolvente"}</p>
                      </div>
                   </div>
                  <ResultadoDataGrid
                    headers={headers}
                    setModal={setModal}
                    columnas={columnasNotas}
                    alumnos={datos}
                    handleAlumno={handleAlumnoCta}
                    titulo={titulo}
                    subtitulo={"Listado de notas que coinciden con tu búsqueda"}
                    seleccion={true}
                  />
                  <div className='flex flex-row justify-end px-3'>
                    <button
                      onClick={() => {
                        setverNotas(false); 
                        //mostrarAdvertencia()
                        }
                      }
                      className='float-right basis-4/4 rounded-md border border-transparent bg-azulBrillanteMira mt-2 py-2 px-4 text-sm font-medium text-white  hover:bg-secundarioMira hover:border-azulLogos focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2'
                    >atrás</button>
                  </div>
                </div>
              }
              </div>
            </div>
          </Container>
       
        </Layout>
      </Transition>
    </>
  )
}

export default NotasAdminIndex